import type { AuthStore } from './interfaces'

import {
  AuthDisplay,
  AuthMethod,
} from '@brighterly/lib-core-types/login/enums'

export const getters = {
  isLoading: (state: AuthStore): AuthStore['loading'] => state.loading,
  getAuthMethod: (state: AuthStore): AuthStore['authMethod'] => state.authMethod,
  isAuthMethodPhone: (state: AuthStore): boolean => state.authMethod === AuthMethod.Phone,
  isAuthMethodEmail: (state: AuthStore): boolean => state.authMethod === AuthMethod.Email,
  getAuthDisplay: (state: AuthStore): AuthStore['authDisplay'] => state.authDisplay,
  isAuthDisplayLogin: (state: AuthStore): boolean => state.authDisplay === AuthDisplay.Login,
  isAuthDisplayOtp: (state: AuthStore): boolean => state.authDisplay === AuthDisplay.Otp,
  getOtpCode: (state: AuthStore): AuthStore['otpCode'] => state.otpCode,
  isOtpError: (state: AuthStore): AuthStore['otpError'] => state.otpError,
  isOtpReSend: (state: AuthStore): AuthStore['otpReSend'] => state.otpReSend,
  isOtpValid: (state: AuthStore): boolean => state.otpCode.length === 4,
  getPhone: (state: AuthStore): AuthStore['phone'] => state.phone,
  isPhoneValid: (state: AuthStore): AuthStore['phoneValid'] => state.phoneValid,
  getEmail: (state: AuthStore): AuthStore['email'] => state.email,
  isEmailValid: (state: AuthStore): AuthStore['emailValid'] => state.emailValid,
  getNotification: (state: AuthStore): AuthStore['notification'] => state.notification,
  isAuthenticated: (state: AuthStore): boolean => !!state.accessToken,
  secondsLeft: (state: AuthStore) => (): number => Math.max(0, Math.floor((state.expiresAt - Date.now()) / 1000)),
  isExpired: (state: AuthStore) => (): boolean => state.expiresAt !== 0 && Date.now() >= state.expiresAt,
}
